document.addEventListener('DOMContentLoaded', () => {
    const btlModal = document.getElementById('btl-modal');
    const btlModalOpen= document.getElementById('btl-modal-open');
    const btlModalClose = document.getElementById('btl-modal-close');

    btlModalOpen?.addEventListener('click', () => {
        btlModal?.classList.add('active');
    });
    btlModalClose?.addEventListener('click', () => {
        btlModal?.classList.remove('active');
    })
    const affordabilityModal = document.getElementById('affordability-modal');
    const affordabilityModalOpen= document.getElementById('affordability-modal-open');
    const affordabilityModalClose = document.getElementById('affordability-modal-close');

    affordabilityModalOpen?.addEventListener('click', () => {
        affordabilityModal?.classList.add('active');
    });
    affordabilityModalClose?.addEventListener('click', () => {
        affordabilityModal?.classList.remove('active');
    })
   
});
